module.exports = __webpack_public_path__ + "img/gobtn.8b283c0f.png";